import { render, staticRenderFns } from "./NewsletterSignupForm.vue?vue&type=template&id=6649ace6&scoped=true&"
import script from "./NewsletterSignupForm.vue?vue&type=script&lang=js&"
export * from "./NewsletterSignupForm.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterSignupForm.vue?vue&type=style&index=0&id=6649ace6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6649ace6",
  null
  
)

export default component.exports